<template>
  <div
    v-if="hasMultipleLocations"
    class="header-location-display location-dropdown-target"
  >
    <cw-dropdown :classes="['is-centered', 'is-black']" :isActive.sync="isOpen">
      <div slot="trigger">
        <div class="dropdown-trigger">
          <span class="has-text-grey-light">{{ currentLocationName }}</span>
          <i class="las la-angle-down has-text-grey-light"></i>
        </div>

        <!-- <button class="button is-medium">
          <span>{{ currentLocationName }}</span>
          <span class="icon is-small">
            <i class="las la-angle-down"></i>
          </span>
        </button> -->
      </div>
      <a
        v-for="location in customerFamily"
        :key="location.customerId"
        class="dropdown-item is-size-5"
        :class="{ 'is-active': location.customerId === selectedCustomerId }"
        @click="selectLocationAndClose(location.customerId)"
      >
        {{ getLocationName(location) }}
      </a>
    </cw-dropdown>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'header-location-display',
  components: {
    'cw-dropdown': () => import('./cwkit/Dropdown.vue'),
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapState('locations', ['customerFamily', 'selectedCustomerId']),
    ...mapGetters('locations', ['hasMultipleLocations', 'currentLocation']),

    currentLocationName() {
      if (!this.currentLocation) return 'Location';
      return this.getLocationName(this.currentLocation);
    },
  },
  mounted() {
    // Emit ready event to notify that location dropdown is ready
    this.$nextTick(() => {
      if (this.hasMultipleLocations) {
        this.$root.$emit('location-dropdown-ready');
      }
    });
  },
  methods: {
    ...mapActions('locations', ['selectLocation']),

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },

    closeDropdown() {
      this.isOpen = false;
    },

    selectLocationAndClose(customerId) {
      this.selectLocation(customerId);
      this.closeDropdown();

      // Navigate to home if not on projects or invoices page
      if (
        this.$route.path !== '/projects' &&
        this.$route.path !== '/invoices'
      ) {
        this.$router.push('/');
      } else {
        // Force refresh the projects page content
        this.$root.$emit('location-changed', customerId);
      }
    },

    getLocationName(location) {
      return (
        location.serviceArea ||
        (location.address && location.address.city) ||
        location.name
      );
    },
  },
  // No need for click outside listener as cw-dropdown handles this
};
</script>

<style scoped>
.header-location-display {
  display: inline-block;
  margin-right: 8px;
}

.header-location-display .button {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
}

.header-location-display .button:hover {
  border-color: white;
}

/* Override default dropdown styles */
.dropdown-item.is-active {
  background-color: #333 !important;
  color: white !important;
}

.header-location-display >>> .dropdown-menu {
  min-width: 200px;
}
</style>
